import React from 'react'

const Service = () => {
  return (
    <section id="services" className="services section">

      {/* <!--End Section Title --> */}
      <div className="container section-title" data-aos="fade-up">
        <h2>Our Services</h2>
        <p>We specialize in providing cutting-edge solutions to help your business grow, streamline operations, and succeed in the digital age.</p>
      </div>
      {/* <!-- End Section Title --> */}

      <div className="container">

        <div className="row gy-4">

          <div className="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay="100">
            <div className="service-item position-relative">
              <div className="icon"><i className="bi bi-laptop icon"></i></div>
              <h4><a href="" className="stretched-link">Web Application Development</a></h4>
              <p>We create responsive, secure, and scalable web applications to meet your business needs and enhance user experience.</p>
            </div>
          </div>
          {/* <!-- End Service Item --> */}

          <div className="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay="200">
            <div className="service-item position-relative">
              <div className="icon"><i className="bi bi-phone icon"></i></div>
              <h4><a href="" className="stretched-link">Mobile Application Development</a></h4>
              <p>Our mobile apps are designed to offer seamless experiences on both iOS and Android, built with the latest technologies.</p>
            </div>
          </div>
          {/* <!-- End Service Item --> */}

          <div className="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay="300">
            <div className="service-item position-relative">
              <div className="icon"><i className="bi bi-code-slash icon"></i></div>
              <h4><a href="" className="stretched-link">Custom Software Development</a></h4>
              <p>We build custom software solutions that are tailored to meet the unique requirements of your business, ensuring efficiency and growth.</p>
            </div>
          </div>
          {/* <!-- End Service Item --> */}

          <div className="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay="400">
            <div className="service-item position-relative">
              <div className="icon"><i className="bi bi-gear icon"></i></div>
              <h4><a href="" className="stretched-link">ERP Solutions</a></h4>
              <p>Our ERP systems integrate all key business functions into one platform, improving data flow and decision-making processes.</p>
            </div>
          </div>
          {/* <!-- End Service Item --> */}

          <div className="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay="500">
            <div className="service-item position-relative">
              <div className="icon"><i className="bi bi-cloud icon"></i></div>
              <h4><a href="" className="stretched-link">Cloud Solutions</a></h4>
              <p>Our cloud solutions offer flexibility, scalability, and cost-efficiency, enabling your business to operate seamlessly across the globe.</p>
            </div>
          </div>
          {/* <!-- End Service Item --> */}

          <div className="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay="600">
            <div className="service-item position-relative">
              <div className="icon"><i className="bi bi-server icon"></i></div>
              <h4><a href="" className="stretched-link">Hosting Services</a></h4>
              <p>Reliable and secure hosting services to ensure your website and applications are always up and running with high availability.</p>
            </div>
          </div>
          {/* <!-- End Service Item --> */}

          <div className="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay="700">
            <div className="service-item position-relative">
              <div className="icon"><i className="bi bi-bar-chart icon"></i></div>
              <h4><a href="" className="stretched-link">Digital Marketing</a></h4>
              <p>We help you grow your brand's online presence through targeted strategies, SEO, social media, and content marketing.</p>
            </div>
          </div>
          {/* <!-- End Service Item --> */}

          <div className="col-xl-3 col-md-6 d-flex" data-aos="fade-up" data-aos-delay="800">
            <div className="service-item position-relative">
              <div className="icon"><i className="bi bi-cart icon"></i></div>
              <h4><a href="" className="stretched-link">Ecommerce Solutions</a></h4>
              <p>Our ecommerce solutions provide everything you need to launch, manage, and scale your online store, boosting sales and performance.</p>
            </div>
          </div>
          {/* <!-- End Service Item --> */}

        </div>

      </div>

    </section>
  )
}

export default Service
